
import {defineComponent} from 'vue'

export default defineComponent({
  name: 'VisualizePanel',
  props: {
    isShowBadge: { type: Boolean, default: true }
  }
})
